<template lang="pug">
d-input-base(
  :component="VTextarea"
  v-bind="extendAttrs"
  v-on="$listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(:name="name" v-bind="data")
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
import DInputBase from './DInputBase.vue';
import { VTextarea } from 'vuetify/lib';

export default {
  components:  { DInputBase, VTextarea },
  props: {
    componentClass: { type: String, default: '' },
  },
  data() {
    return {
      VTextarea,
    };
  },
  computed: {
    extendAttrs() {
      return {
        placeholder: 'Начните вводить...',
        rows: 3,
        autoGrow: true,
        componentClass: [
          'dv-textarea',
          this.componentClass,
        ].filter(Boolean).join(' '),
        ...this.$attrs,
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
